import { Delete } from "../../../../../../svg/delete";
import EditPencilIcon from "../../../../../../svg/editPencil";

interface DraggableOptionCardProps {
  label: string;
  value: string;
  priority?: number;
  color?: string;
  textColor?: string;
  isDragging?: boolean;
  onEdit: () => void;
  onDelete: () => void;
}

const DraggableOptionCard = (props: DraggableOptionCardProps) => {
  return (
    <div
      className={`group flex cursor-grab items-center justify-between rounded-lg border border-gray-200 bg-white px-4 py-3 transition-all duration-200 hover:-translate-y-0.5 hover:border-gray-300 hover:shadow-md active:translate-y-0 active:cursor-grabbing active:shadow-lg ${
        props.isDragging ? "opacity-50 shadow-lg" : ""
      }`}
    >
      <div className="flex flex-1 items-center gap-3 overflow-hidden">
        {(props.color || props.textColor) && (
          <div className="flex flex-shrink-0 flex-col gap-1">
            {props.color && (
              <div
                className="h-3 w-3 rounded-full border border-gray-300"
                style={{ backgroundColor: props.color }}
              />
            )}
            {props.textColor && (
              <div
                className="h-3 w-3 rounded-full border border-gray-300"
                style={{ backgroundColor: props.textColor }}
              />
            )}
          </div>
        )}
        <div className="flex flex-1 flex-col overflow-hidden">
          <span className="truncate text-sm font-medium text-gray-900">
            {props.label || props.value}
          </span>
          {props.label && props.label !== props.value && (
            <span className="truncate text-xs text-gray-500">
              {props.value}
            </span>
          )}
        </div>
      </div>

      <div className="flex items-center gap-3">
        <span className="min-w-[32px] rounded bg-gray-100 px-2 py-0.5 text-center text-xs font-medium text-gray-600">
          {props.priority !== undefined ? props.priority : "-"}
        </span>

        <div className="flex items-center gap-1">
          <button
            onClick={(e) => {
              e.stopPropagation();
              props.onEdit();
            }}
            className="rounded p-1.5 text-gray-400 transition-colors hover:text-blue-600"
            title="Edit"
          >
            <EditPencilIcon height={14} width={14} stroke="#9CA3AF" />
          </button>
          <button
            onClick={(e) => {
              e.stopPropagation();
              props.onDelete();
            }}
            className="rounded p-1.5 text-gray-400 transition-colors hover:text-red-600"
            title="Delete"
          >
            <Delete height={14} width={14} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default DraggableOptionCard;
